import React, { useContext } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

import './panelists.scss';

// import required modules
import { Navigation, Pagination } from 'swiper/modules';
import { WidthContext } from '../../WidthContext';
import Panelist from './Panelist';

const SwiperCarousel = ({ data }) => {
  const { touch } = useContext(WidthContext);

  return (
    <Swiper
      slidesPerView={1}
      slidesPerGroup={1}
      spaceBetween={0}
      navigation={touch ? false : true}
      cssMode={true}
      pagination={
        touch
          ? {
              el: '.pagination-container',
              clickable: true
            }
          : false
      }
      modules={[Pagination, Navigation]}
      breakpoints={{
        1025: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        1441: {
          slidesPerView: 3
        }
      }}
      className="panelists__carousel"
    >
      <div className="pagination-container"></div>

      {data &&
        data.map((data) => (
          <SwiperSlide className="panelists__item" key={data.c}>
            <Panelist data={data} />
          </SwiperSlide>
        ))}
    </Swiper>
  );
};

export default SwiperCarousel;
